var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"pointer-events-none",attrs:{"color":"#FCF5F8","text-color":"#e95d65","x-small":"","label":""}},[_vm._v("Required")])
}
var staticRenderFns = []

export { render, staticRenderFns }